import React from "react";
import cn from "classnames";
import styles from "./Row.module.sass";
import Checkbox from "../../../../../components/Checkbox";

const ToteTableRow = ({ data, checkedItems = {}, handleCheckboxChange }) => {

  const handleRowClick = (event) => {
    if (event.target.type === 'Checkbox' || event.target.className.includes('Checkbox')) {
      event.stopPropagation();
      return;
    }
    window.open(`/order-details/${data.order?.order_number}`, '_blank');
  };
  const handleCheckboxClick = (e) => {
    e.stopPropagation();
    handleCheckboxChange(e, null, data.order?.id);
  };
  return (
    <div className={cn(styles.row,"cursor-pointer")} onClick={handleRowClick}>
      <div className={styles.col}>
        <Checkbox
          className={styles.checkbox}
          checked={checkedItems[data.order?.id] || false}
          onChange={handleCheckboxClick}
        />
      </div>
      <div className={cn(styles.col)}> {data.order?.name || "-"} </div>
      <div className={cn(styles.col)}> </div>
      <div className={cn(styles.col)}> </div>
      <div className={cn(styles.col)}> </div>
    </div>
  );
};

export default ToteTableRow;
